import axios from "axios";
import client from "../axiosConfig/axios";

const login = (data: string) => {
  return client.post("/auth/sign-in", data);
};

const registerEmployee = (data: any) => {
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return client?.post(`/auth/register`, data, options);
};

const deleteEmployee = (data: any) => {
  return client?.delete(`/app/users/${data}`);
};

const editEmployee = (data: any) => {
 
  const payload = {
    status: data.status,
  };

  const formData = new FormData();
  if (data.image) {
    formData.append("image", data.image);
  }
  formData.append("firstname", data.firstname);
  formData.append("lastname", data.lastname);
  formData.append("email", data.email);
  formData.append("department", data.department);
  formData.append("job_role", data.job_role);
  formData.append("datejoined", data.datejoined);
  formData.append("city", data.city);
  formData.append("country", data.country);
  formData.append("phone", data.phone);
  formData.append("employment_type", data.employment_type);
  formData.append("lead", data.lead);

  return client?.patch(
    `/app/users/${data.id}`,
    data.status ? payload : data
  );
};

const createAnnouncment = (data: any) => {
  return client?.post(`/app/announcement`, data);
};

const getAllAnnouncement = () => {
  // console.log("tokennnnnn", token);

  // return axios.get("https://vault.lifebanktest.com/api/v1/app/announcement", {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // });
  return client?.get(`/app/announcement`);
};

const getSingleAnnouncement = (id: any) => {
  return client?.get(`/app/announcement/${id}`);
};

const sop = () => {
  return client?.get(`/app/sop`);
};

const getSingleSop = (id: string) => {
  return client?.get(`/app/sop/${id}`);
};

const applyForRaise = (data: {
  name: string;
  designation: string;
  department: string;
  date: Date;
  comments: string;
  userId: number;
}) => {
  return client?.post(`/app/growth-raise`, data);
};

const changeDepartment = (data: {
  CurrentDepartment: string;
  CurrentRole: string;
  Reason: string;
  PreferredDepartment: string;
  Skill: string;
  Qualification: string;
}) => {
  return client?.post(`/app/change-department`, data);
};

const referFriend = (data: any) => {
  return client?.post(`/app/refer-friend`, data);
};

const getUserStat = () => {
  return client?.get("/app/users/statistics");
};

const employerOfMonth = (data: any) => {
  return client?.post(`/app/employee-of-month`, data);
};

const getEmployeeOfMonth = () => {
  return client?.get(
    `/app/employee-of-month/${[
      new Date().getMonth() + 1,
    ]}/${new Date().getFullYear()}`
  );
};

const getUser = () => {
  return client?.get(`/app/users`);
};
const getSingleUser = (id: number) => {
  return client?.get(`/app/user/${id}`);
};

const allRequest = () => {
  return client?.get("/app/requests");
};

const singleRequest = (id: number) => {
  return client?.get(`/app/requests/${id}`);
};

const treatRequest = (id: any, data: any) => {
  return client?.patch(`/app/requests/${id}`, data);
};

const raise = (data: any) => {
  return client?.post("/app/raise", data);
};

const fitIn = (data: any) => {
  return client?.post("/app/change-department", data);
};

const getNotification = (id: string) => {
  return client?.get(`/app/notifications/${id}`);
};

const markasRead = (id: any) => {
  return client?.get(`/app/notifications/mark/${id}`);
};

const markAttendance = (
  payload: {
    user: number;
    ip: string;
    location: string;
  },
  checkType: string
) => {
  return client?.post(`/app/users/attendance/${checkType}`, payload);
};

const getLastAttendance = async (user: number) => {
  return await client?.get(`/app/user/last/attendance/${user}`);
};

const getIndividualAttendance = async (user: number) => {
  return await client?.get(`/app/user/individual/${user}`);
};

const getUserLocation = async () => {
  // return await axios.get("https://ipapi.co/json/");
  return await axios.get("https://freeipapi.com/api/json");
};

const getEmployeesAttendance = async (startDate: string, endDate: string) => {
  return await client?.get(`/app/users/clock/${startDate}/${endDate}`);
};

const getEmployeeAddresses = async (latitude: any, longitude: any) => {
  const apiKey = "AIzaSyDQjd9fzSdMQzaCXmjXMlfJILG53ZVJs5M"; // Replace with your actual API key
  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;
  return await axios.get(url);
};

const getQuarterlyGoals = async (quarter: string) => {
  return await client?.get(`/app/target/quarter/${quarter}`);
};

const getAnnualGoals = async () => {
  return await client?.get(`/app/target/year`);
};

const getTrueNorth = async () => {
  return await client?.get(`/app/true/north`);
};

const getDepartments = async () => {
  return await client?.get(`/app/department`);
};

export {
  login,
  registerEmployee,
  deleteEmployee,
  editEmployee,
  createAnnouncment,
  getSingleAnnouncement,
  getAllAnnouncement,
  sop,
  getSingleSop,
  applyForRaise,
  changeDepartment,
  referFriend,
  employerOfMonth,
  getEmployeeOfMonth,
  getUser,
  getSingleUser,
  getUserStat,
  allRequest,
  singleRequest,
  treatRequest,
  raise,
  fitIn,
  getNotification,
  markasRead,
  markAttendance,
  getUserLocation,
  getLastAttendance,
  getIndividualAttendance,
  getEmployeesAttendance,
  getEmployeeAddresses,
  getQuarterlyGoals,
  getAnnualGoals,
  getTrueNorth,
  getDepartments,
};
